// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.lease.LeaseOuidWebApiHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeaseOuidWebApiHandler_getLeaseFromOuid,
  LeaseOuidWebApiHandler_getLeaseFromOuid_Path,
  LeaseOuidWebApiHandler_getLeaseFromOuidV2,
  LeaseOuidWebApiHandler_getLeaseFromOuidV2_Path,
} from '@zg-rentals/ts-leasing-client';

import type { GetLeaseResponseDto, GetLeaseV2ResponseDto } from '@zg-rentals/ts-leasing-client';

interface GetLeaseFromOuidParams {
  ouid: string;
}
interface GetLeaseFromOuidV2Params {
  ouid: string;
}

export type LeaseOuidWebApiHandler_getLeaseFromOuid_Options = UseQueryOptions<
  GetLeaseResponseDto,
  unknown,
  GetLeaseResponseDto,
  readonly [string, GetLeaseFromOuidParams]
>;

const LeaseOuidWebApiHandler_getLeaseFromOuid_GetKey = (getParams: GetLeaseFromOuidParams) =>
  [LeaseOuidWebApiHandler_getLeaseFromOuid_Path, getParams] as const;

export const LeaseOuidWebApiHandler_getLeaseFromOuid_queryOptions = (
  getParams: GetLeaseFromOuidParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeaseOuidWebApiHandler_getLeaseFromOuid_GetKey(getParams),
    queryFn: () => LeaseOuidWebApiHandler_getLeaseFromOuid(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get lease from ouid
 */
export const useLeaseOuidWebApiHandler_getLeaseFromOuid = (
  getParams: GetLeaseFromOuidParams,
  {
    httpClient,
    ...options
  }: Omit<LeaseOuidWebApiHandler_getLeaseFromOuid_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeaseOuidWebApiHandler_getLeaseFromOuid_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeaseOuidWebApiHandler_getLeaseFromOuid.getKey = LeaseOuidWebApiHandler_getLeaseFromOuid_GetKey;

export type LeaseOuidWebApiHandler_getLeaseFromOuidV2_Options = UseQueryOptions<
  GetLeaseV2ResponseDto,
  unknown,
  GetLeaseV2ResponseDto,
  readonly [string, GetLeaseFromOuidV2Params]
>;

const LeaseOuidWebApiHandler_getLeaseFromOuidV2_GetKey = (getParams: GetLeaseFromOuidV2Params) =>
  [LeaseOuidWebApiHandler_getLeaseFromOuidV2_Path, getParams] as const;

export const LeaseOuidWebApiHandler_getLeaseFromOuidV2_queryOptions = (
  getParams: GetLeaseFromOuidV2Params,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeaseOuidWebApiHandler_getLeaseFromOuidV2_GetKey(getParams),
    queryFn: () => LeaseOuidWebApiHandler_getLeaseFromOuidV2(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get lease from ouid
 */
export const useLeaseOuidWebApiHandler_getLeaseFromOuidV2 = (
  getParams: GetLeaseFromOuidV2Params,
  {
    httpClient,
    ...options
  }: Omit<LeaseOuidWebApiHandler_getLeaseFromOuidV2_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...LeaseOuidWebApiHandler_getLeaseFromOuidV2_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeaseOuidWebApiHandler_getLeaseFromOuidV2.getKey = LeaseOuidWebApiHandler_getLeaseFromOuidV2_GetKey;
